<form #form="ngForm" column-classes="col-md-4,col-md-8">
  <div class="row mt-2">
    <div class="col-5">
      <h3 class="title-divider">{{ "datenexport.auswahlAuftragstyp" | translate }}</h3>
      <ul class="list-group mt-2">
        @for (item of itemsList; track item) {
          <li class="list-group-item">
            <div class="ms-2 form-check-inline">
              <input
                (change)="updateTypeSelection()"
                [(ngModel)]="radioTypeSelectedIndex"
                [disabled]="readonly"
                class="form-check-input me-2"
                id="{{ item.name }}"
                name="{{ item.name }}"
                type="radio"
                value="{{ item.value }}" />
              <label class="form-check-label" for="{{ item.name }}">
                {{ "datenexport." + item.name | translate }}
              </label>
            </div>
          </li>
        }
      </ul>
    </div>
    <div class="col-7">
      <h3 class="title-divider">{{ "Beschreibung" | translate }}</h3>
      <div class="mt-2">
        <span>{{ currentItemSelected?.beschreibung | translateName }}</span>
      </div>
    </div>
  </div>

  @if (!readonly) {
    <div class="row mt-2">
      <div class="col-12">
        <h3 class="title-divider">{{ "datenexport.auswahlAuftragsexportTemplate" | translate }}</h3>
        <ng-container class="cap-table-wrapper-content">
          <cap-list-loader [hasRight]="true" [listLoader]="templateListLoader" [showTotal]="false" [showZeilenSelect]="false">
            <div class="cap-list-loader-content">
              <table class="cap-table-detail">
                <thead>
                  <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
                </thead>
                <tbody>
                  <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
                </tbody>
              </table>
            </div>
          </cap-list-loader>
          <ng-template #tableHeaders>
            <tr>
              <th id="Selection" style="width: 5%"></th>
              <th id="Bezeichnung" style="width: 20%">{{ "Bezeichnung" | translate }}</th>
              <th id="Beschreibung" style="width: 45%">{{ "Beschreibung" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #tableRows>
            @if (templateListLoader?.items) {
              @for (item of templateListLoader?.items; track item) {
                <tr>
                  <td>
                    <input
                      (change)="updateTemplateSelection()"
                      [(ngModel)]="templateSelectedBezeichnung"
                      [checked]="item.selected"
                      name="template_radiogroup"
                      type="radio"
                      value="{{ item.bezeichnung }}" />
                  </td>
                  <td>{{ item.bezeichnung }}</td>
                  <td>{{ item.beschreibung | translateName }}</td>
                </tr>
              }
            }
          </ng-template>
        </ng-container>
      </div>
    </div>
  }
  @if (!readonly) {
    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button class="btn btn-outline-primary btn-actionpane" routerLink=".." type="button">{{ "Abbrechen" | translate }}</button>
        <button [disabled]="!currentTemplateSelected" cdkStepperNext class="btn btn-primary btn-actionpane" type="button">
          {{ "Weiter" | translate }}
        </button>
      </div>
    </div>
  }
</form>
